//*mobile*//
var blockTempSearch = false;

// Pagine "contenuto": renderizzate come pagine reali (.pageMob-*) dal loro
// renderer (loadPageVideo / getInfoCollection / getPlaylistContents), che
// gestisce anche il layer nello stack ('video-<id>', 'collection-<id>',
// 'playlist-<id>'): per loro navigateToPage NON tocca Nav (niente resetTo).
var CONTENT_PAGES = ['video', 'collection', 'playlistview'];

function isNativeApp(){
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
}

function applyAndroidHeaderTopSpacingFix(){
    var ua = navigator.userAgent || '';
    var isNative = false;
    var isAndroid = false;
    try {
        isNative = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    } catch (e) {}
    if(!isNative && ua.indexOf('Teyuto-Capacitor') !== -1){
        isNative = true;
    }
    if(!isNative){
        return;
    }
    try {
        isAndroid = !!(window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform() === 'android');
    } catch (e) {}
    if(!isAndroid){
        isAndroid = /Android/i.test(ua);
    }
    if(!isAndroid){
        return;
    }
    try {
        document.documentElement.classList.add('ty-native', 'ty-android');
    } catch (e) {}
    $('.header-mobile-native-nav').css('padding-top', '22px');
}

function navigateToPage(type, back = false) {
    var isGuestUser = (typeof userData === 'undefined' || !userData || userData.status != 'success');
    if (type === 'profile' && isNativeApp() && isGuestUser) {
        openModalLogin();
        return false;
    }

    //fix
    try{
        onscrolleventbackup_header();
    }catch(err){}
    //

    // segnale sul body per il CSS web (header nascosto nella pagina video);
    // sul nativo la classe è inerte
    try { document.body.classList.toggle('ty-video-open', type === 'video'); } catch (e) {}

    var isContentPage = (CONTENT_PAGES.indexOf(type) !== -1);

    // initPlaylistSection ('saved') nasconde .sectionContainer (retaggio del
    // vecchio webapp): le pagine contenuto vivono LÌ dentro, quindi ogni
    // navigazione lo riporta visibile (per 'saved' viene rinascosto dopo)
    $('.sectionContainer').show();

    // teardown centralizzato delle pagine che si stanno lasciando: le pagine
    // contenuto (e la home, la più pesante) vengono SVUOTATE, non nascoste —
    // player fermati, poi .html('') così immagini/video/listener liberano
    // memoria. Al ritorno si ri-renderizzano da zero (API cacheate da jalc).
    if(type !== 'video'){ destroyVideoPage(); }
    if(type !== 'collection'){ destroyCollectionPage(); }
    if(type !== 'playlistview'){ $('.pageMob-playlistview .playlistview-content').html(''); }
    if(type !== 'home'){ destroyHomePage(); }

    // Blocco login disattivato per 'download' e 'saved': le sezioni si aprono
    // anche senza utente loggato.
    // (originale: if((type == 'download' || type == 'saved') && (userData.status != 'success') && ONLINE_STATUS==true){ openModalLogin(); return false; })
    // alert("we");
    if(type == 'home'){
        try{
            onscrolleventbackup_home();
        }catch(er){}
        $('#mobile-logo-native-img').show();
        $('#mobile-logo-native-label').hide();
        if(companyCustomHomePages.length > 0){
            $('.mobile-list-page').show();
        }
        // home smontata all'uscita: ri-render della pagina custom attiva.
        // CHANNEL_ID assente = primissima navigateToPage all'avvio: il primo
        // render lo farà app.js dopo il load dei dati canale
        if($('.pageMob-home').children().length === 0 && typeof CHANNEL_ID !== 'undefined' && CHANNEL_ID){
            var homeTarget = (typeof tyResolveHomePageTarget === 'function')
                ? tyResolveHomePageTarget(1, 'user')
                : { type: 1, idCustom: 'user' };
            if(currentCustomPageActive && currentCustomPageActive !== 'user' && currentCustomPageActive !== 'guest'){
                loadHomepageSections('page', CHANNEL_ID, 0, null, null, currentCustomPageActive);
            }else{
                loadHomepageSections(homeTarget.type, CHANNEL_ID, 0, null, null, homeTarget.idCustom);
            }
            if(back == true){
                restoreHomeScrollDepth();
            }
        }
    }else{
        $('#mobile-logo-native-img').hide();
        $('#mobile-logo-native-label').show();
    }

    if(back == true && !isContentPage){
        $('html, body').animate({scrollTop: currentPageDepth[type] || 0}, 0);
    }else{
        //l'azione è voluta (le pagine contenuto partono sempre dalla cima)
        setTimeout(function() {
            $('html, body').animate({scrollTop: 0}, 0);
        }, 50);
    }

    // una pagina nuova copre e azzera ogni modal aperta
    try{ Nav.closeAllModals(); }catch(er){}

    if(back == false && !isContentPage){
       // navigazione diretta (bottom bar / header web): nuova entry di history
       Nav.push(type);
    }

    // console.log(type);
    if(companyCustomHomePages.length>0){
        $('.mobile-list-page').hide();
    }

    if(type == "profile"){
        $('#mobile-logo-native-label').html(translate('PROFILE'));
        //$('#header-user-img-profile').hide();
        //$('#header-user-settings-icon').show();
    }else if(!isContentPage){
        //$('#header-user-img-profile').show();
        //$('#header-user-settings-icon').hide();
        $('.menu-item').removeClass('active');
        $('.menu-item[rel="' + type + '"]').addClass('active');
    }
    updateNavIndicator();

    if(type == 'saved'){        
        $('#mobile-logo-native-label').html(`${translate('BROWSE_SAVED')}`);
        initPlaylistSection();
    }

    if(type == 'download'){
        $('#mobile-logo-native-label').html(translate('DOWNLOADS'));
        try {
            var isNativeIOS = !!(window.Capacitor &&
                window.Capacitor.isNativePlatform &&
                window.Capacitor.isNativePlatform() &&
                window.Capacitor.getPlatform &&
                window.Capacitor.getPlatform() === 'ios');
            if (isNativeIOS) {
                var localBase = (typeof window.WEBVIEW_SERVER_URL === 'string' && window.WEBVIEW_SERVER_URL) || 'capacitor://localhost';
                var sep = localBase.charAt(localBase.length - 1) === '/' ? '' : '/';
                var target = localBase + sep + 'downloads.html?return=' + encodeURIComponent(location.href);
                location.href = target;
                return false;
            }
        } catch (e) {}
        listDownloaded();
    }

    // le pagine contenuto sono immersive: header dell'app nascosto,
    // hanno il loro bottone indietro.
    // Per rimostrare si toglie il display inline invece di .show(): su web
    // desktop header e navbar sono nascosti da web.css e jQuery scriverebbe
    // display:block inline, che restringendo la finestra (o ruotando un
    // tablet) batte il flex di mobile.css — il cerchio Cerca andava a capo
    if(isContentPage){
        $('.header-mobile-native').hide();
    }else{
        $('.header-mobile-native').css('display', '');
    }

    // pagina video senza navbar (come la vecchia modal); ovunque altrove torna
    if(type === 'video'){
        $('.navbar-mobile-native').hide();
    }else{
        $('.navbar-mobile-native').css('display', '');
    }

    if(type == 'search'){
        $('#mobile-logo-native-label').html(translate('SEARCH'));

        $('.resultsSearchTxt').hide();
        $('.searchForMobile').show();
        $('.headerSearchRemoveIcon').hide();

        if (companyNumberCategories == 0) {
            $('.search-mobile-categories-box').hide();
        }else{
            $('.search-mobile-categories-box').show();
        }
        
        $('.headerSearchGlobalInputMobile').val('');
        $('#mainLiveHomeMobile').html('');
        $('#mainLiveHomeMobile').hide();
    }
    
    $('.pageMob').hide();
	$('.pageMob-'+type).show();
    animatePageEnter($('.pageMob-'+type));

    // video/collection notificano l'analytics dopo il load dei dati
    // (setFirebaseAnalyticsPage in live.js/collections.js): niente doppioni
    if(!isContentPage){
        setFirebaseAnalyticsPage(type);
    }

    // rete di sicurezza: su iOS il layout viewport della WebView può restare
    // con dimensioni stale dopo un fullscreen/rotazione della pagina video
    // (vedi setVideoRotateFullscreen in live.js), disallineando la scrollbar
    // nativa nella pagina appena aperta (es. una collezione). Costo
    // trascurabile: solo su iOS nativo, solo al cambio pagina.
    try{
        if(typeof isIOSNativeApp === 'function' && isIOSNativeApp() &&
           typeof refreshIOSLayoutViewport === 'function'){
            refreshIOSLayoutViewport();
        }
    }catch(e){}

    // seconda rete di sicurezza per lo stesso sintomo: su nativo non deve mai
    // restare un paddingRight inline sul body (retaggio della compensazione
    // scrollbar-width di BSLight, pensata solo per desktop - vedi ModalShow
    // in bsjslight3.min.js). Se rimane appiccicato da una modale aperta
    // durante una rotazione, il contenuto/scrollbar risultano spostati verso
    // il centro invece che sul bordo: lo ripuliamo ad ogni cambio pagina.
    try{
        if(typeof isNativeApp === 'function' && isNativeApp() && document.body.style.paddingRight){
            document.body.style.paddingRight = '';
        }
    }catch(e){}
}

// Teardown della pagina video: player, glow ambientale e DOM. Centralizzato
// qui e invocato da navigateToPage ogni volta che si lascia la pagina.
// Sulle navigazioni successive la pagina è già vuota (early return).
function destroyVideoPage(){
    if($('#video-section-unique').children().length === 0){ return; }
    try{ clearInterval(window.ambientLightTimer); }catch(e){}
    // il fullscreen da rotazione non deve sopravvivere alla pagina, e fuori
    // dal video l'app torna portrait: la pagina video è l'unica che sblocca
    // l'orientamento (vedi createVideoSection)
    try{ setVideoRotateFullscreen(false); }catch(e){}
    try{ tyLockPortrait(); }catch(e){}
    lastVideoSource = null;
    lastVideoIdOpened = null;
    // fuori dalla pagina video il bottone Cast dell'header non ha piu' un
    // video da mandare al ricevitore
    try{ setCastSource(null, null); }catch(e){}
    try{ teyutoVideoPlayer.dispose(); }catch(e){}
    $('#video-section-unique').html('');
}

// Teardown della pagina collection: trailer preview e glow ambientale
function destroyCollectionPage(){
    var $content = $('.pageMob-collection .modal_popup_lc_content');
    if($content.children().length === 0){ return; }
    try{ clearInterval(window.collectionAmbientTimer); }catch(e){}
    try{ teyutoPreviewPlayer.dispose(); }catch(e){}
    $content.html('');
}

// Teardown della home (la pagina più pesante: slideshow/spotlight, rail):
// prima la hook web (hero/trailer; su nativo non esiste e si salta), poi lo
// stop di eventuali player rimasti e lo svuotamento. Il flusso di caricamento
// progressivo a scroll riparte da zero al prossimo render.
function destroyHomePage(){
    var $home = $('.pageMob-home');
    if($home.children().length === 0){ return; }
    if(typeof tyWebHomeTeardown === 'function'){
        try{ tyWebHomeTeardown(); }catch(e){}
    }
    $home.find('video').each(function(){
        try{ this.pause(); this.removeAttribute('src'); this.load(); }catch(e){}
    });
    stepHomepageSections = 1;
    semapWindowsScrollHomepage = 0;
    $home.html('');
}

// Ripristino best-effort dello scroll della home dopo il ri-render: attende
// che l'altezza della pagina copra la profondità salvata (le sezioni arrivano
// progressivamente e lo scroll programmatico ne innesca il caricamento), con
// timeout di sicurezza. La profondità va letta SUBITO: il reset dello scroll
// che segue la sovrascriverebbe.
function restoreHomeScrollDepth(){
    var target = currentPageDepth['home'] || 0;
    if(target <= 0){ return; }
    var tries = 0;
    var timer = setInterval(function(){
        tries++;
        if(currentPageState[currentPageState.length-1] !== 'home' || tries > 40){
            clearInterval(timer);
            return;
        }
        if(document.documentElement.scrollHeight >= target + window.innerHeight){
            $('html, body').scrollTop(target);
            clearInterval(timer);
        }
    }, 100);
}

// ingresso leggero della pagina; la classe va rimossa a fine animazione,
// altrimenti il transform resta attivo e sposta gli elementi position:fixed
function animatePageEnter($page){
    if($page.length === 0){ return; }
    $page.removeClass('pageMob-enter');
    void $page[0].offsetWidth;
    $page.addClass('pageMob-enter');
    $page.one('animationend', function(){
        $(this).removeClass('pageMob-enter');
    });
}

// pill "liquida" della navbar: un unico indicatore che scivola sul tab attivo.
// Due fasi: prima si allunga fino a coprire vecchio e nuovo tab, poi si
// contrae sul nuovo (effetto gooey). Con animate=false si riposiziona secco.
// altezza reale della navbar esposta come CSS var (--navbar-mobile-h)
function updateNavbarHeightVar(){
    var nav = $('.navbar-mobile-native')[0];
    if(nav && nav.offsetHeight > 0){
        document.documentElement.style.setProperty('--navbar-mobile-h', nav.offsetHeight + 'px');
    }
}

var navIndicatorTimer = null;
function updateNavIndicator(animate){
    var menu = $('.navbar-mobile-native .menu')[0];
    var pill = $('.navbar-mobile-native .menu-active-pill')[0];
    if(!menu || !pill){ return; }
    // solo i tab dentro la pill: se è attivo il cerchio Cerca (staccato)
    // la pill sparisce e si illumina il cerchio via CSS
    var active = $('.navbar-mobile-native .menu .menu-item.active:visible')[0];
    if(!active){ pill.style.opacity = '0'; return; }

    var newLeft = active.offsetLeft;
    var newWidth = active.offsetWidth;
    var curLeft = pill.offsetLeft;
    var curWidth = pill.offsetWidth;
    clearTimeout(navIndicatorTimer);

    var firstPlacement = (pill.style.opacity !== '1' || curWidth === 0);
    if(animate === false || firstPlacement){
        pill.classList.add('no-anim');
        pill.style.left = newLeft + 'px';
        pill.style.width = newWidth + 'px';
        pill.style.opacity = '1';
        void pill.offsetWidth; // applica subito, poi riattiva le transition
        pill.classList.remove('no-anim');
        return;
    }
    if(newLeft === curLeft && newWidth === curWidth){ return; }

    var stretchLeft = Math.min(curLeft, newLeft);
    var stretchRight = Math.max(curLeft + curWidth, newLeft + newWidth);
    pill.style.left = stretchLeft + 'px';
    pill.style.width = (stretchRight - stretchLeft) + 'px';
    navIndicatorTimer = setTimeout(function(){
        pill.style.left = newLeft + 'px';
        pill.style.width = newWidth + 'px';
    }, 190);
}

$(document).ready(function () {
    applyAndroidHeaderTopSpacingFix();

    // se offline carico questo
    // if(ONLINE_STATUS==false){
    // }
    
    if(DEBUG == true){
        localStorage.clear();
        setInterval(() => {
            
            if($('#debugBox').length == 0){
                $('body').append('<div id="debugBox" style="position:fixed; top:100px; left:0px; background:yellow; color:black;padding:5px;width:100%;z-index:99999999999999999999999999999999999999999999999!important;">init debug</div>');
            }
            $('#debugBox').html(currentPageState);
        }, 1000);
    }

    // cast + avatar dell'header uniti in una capsula stile iOS
    $('.header-mobile-native-nav .mobile-chromecast, .header-mobile-native-nav .mobile-profile')
        .wrapAll('<div class="header-actions-capsule"></div>');

    // indicatore liquido della navbar: creato prima della prima navigateToPage
    $('.navbar-mobile-native .menu').prepend('<div class="menu-active-pill"></div>');
    // il tab Cerca vive in un cerchio staccato dalla pill (stile tab bar iOS)
    var $searchTab = $('.navbar-mobile-native .menu .menu-item[rel="search"]');
    if($searchTab.length){
        $('<div class="nav-search-detached"></div>')
            .appendTo('.navbar-mobile-native')
            .append($searchTab);
    }
    updateNavbarHeightVar();
    try{
        // riallinea pill e altezza se la navbar cambia dimensioni
        var navResizeObs = new ResizeObserver(function(){
            updateNavIndicator(false);
            updateNavbarHeightVar();
        });
        navResizeObs.observe($('.navbar-mobile-native')[0]);
        navResizeObs.observe($('.navbar-mobile-native .menu-item')[0]);
    }catch(e){}
    window.addEventListener('resize', function(){
        updateNavIndicator(false);
        updateNavbarHeightVar();
    });

    $('#btn-mobile-profile').click(function(){
        navigateToPage('profile');
    });

    let menuItemMobile = $(".menu-item");

	menuItemMobile.click(function() {
        var type = $(this).attr('rel');
        navigateToPage(type, false);
	});

  // loadPageVideo(1423);
    //gestisco la barra sulla base dellorientamento
    window.addEventListener('resize', function() {
        console.log("resize");
        // su web desktop il viewport è SEMPRE landscape: la classe fullscreen
        // da orientamento non ha senso (il layout lo gestisce live.css)
        if(window.TY_WEB && window.innerWidth >= 992){
            $('#video-container-big').removeClass('videoFullScreen');
            return;
        }
        //verifico se mi trovo effettivamente nella pagina corretta video
        if(window.innerHeight > window.innerWidth) {
            // Portrait
            $('#video-container-big').removeClass('videoFullScreen');
            // $('.modal-dialog').css('background','none'); //fix full screen background logo
        } else {
            $('#video-container-big').addClass('videoFullScreen');
            // $('.modal-dialog').css('background','black'); //fix full screen background logo
        }
    });

    onscrolleventbackup_header = function () {
        var lastScrollTop = 0;
        $(document).on('scroll', function() {
        var st = $(this).scrollTop();
        currentPageDepth[currentPageState[currentPageState.length-1]] = st;
        // console.log(JSON.stringify(currentPageDepth));
        if(st==0){
           $('.header-mobile-native').css('opacity', '1');
           return false;
        }
        if (st < lastScrollTop) {
            // Scroll verso l'alto o fermo
            $('.header-mobile-native').css('opacity', '1');
        } else {
            // Scroll verso il basso
            $('.header-mobile-native').css('opacity', '0');
        }
        lastScrollTop = st;
        });

        setTimeout(function() {
            $('.header-mobile-native').css('opacity', '1');
        }, 50);
    }

    onscrolleventbackup_header();

    var windowHeight = window.innerHeight;
    var startY, initialTouchPos, modalContent, isDragging = false, pressTimer;
    var pressThreshold = 100; // Millisecondi di pressione prima di attivare il drag

    $('.modal-dialog').on('mousedown touchstart', function(event) {
        modalContent = $(this);
        startY = event.type === 'mousedown' ? event.pageY : event.touches[0].pageY;
        initialTouchPos = startY;

        // Avvia il timer per la pressione prolungata
        pressTimer = setTimeout(function() {
            isDragging = true;
            modalContent.addClass('dragging');
        }, pressThreshold);

        $(document).on('mousemove touchmove', function(event) {
            if (!isDragging) {
                // Se non stiamo ancora trascinando, controlla se il movimento è significativo
                var currentY = event.type === 'mousemove' ? event.pageY : event.touches[0].pageY;
                if (Math.abs(currentY - startY) > 10) { // Soglia di movimento
                    clearTimeout(pressTimer);
                }
                return;
            }
            var touchY = event.type === 'mousemove' ? event.pageY : event.touches[0].pageY;
            var touchYDelta = touchY - initialTouchPos;
            if (touchYDelta > 0) { // Move down
                requestAnimationFrame(function() {
                    modalContent.css('transform', 'translateY(' + (touchYDelta * 1.5) + 'px)');
                });
            }
        });

        $(document).on('mouseup touchend', function(event) {
            clearTimeout(pressTimer);
            $(document).off('mousemove touchmove mouseup touchend');
            if (!isDragging) return;
            isDragging = false;
            modalContent.removeClass('dragging');

            var finalTouchPos = event.type === 'mouseup' ? event.pageY : event.changedTouches[0].pageY;
            var touchYDelta = finalTouchPos - startY;
            
            if (touchYDelta > (windowHeight / 3.5)) {
                requestAnimationFrame(function() {
                    modalContent.css({
                        'transform': 'translateY(' + windowHeight + 'px)',
                        'transition': 'transform 0.1s ease'
                    });
                });
                requestAnimationFrame(function() {
                    modalContent.css({
                        'transform': '',
                        'transition': ''
                    });
                });
                checkGeneralCurrentState();
            } else {
                requestAnimationFrame(function() {
                    modalContent.css({
                        'transform': '',
                        'transition': 'transform 0.1s ease'
                    });
                });
            }
        });
    });

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            document.activeElement.blur();
        }
    });

    // Il popstate è gestito da Nav (js/nav.js): unico punto in cui lo stack
    // viene decrementato, in sincrono con la history del browser.

    if (window.TY_WEB && typeof tyWebInitialRoute === 'function') {
        // web (shell PHP): l'URL è una pagina reale (/video?w=, /collection?s=,
        // /page?id_custom=...) e va aperta direttamente — vedi js/web.js
        tyWebInitialRoute();
    } else {
        navigateToPage('home'); //diventa home |todo
    }

    //quando chiudo le modal per sicurezza ruoto di nuovo
    $('.modal .close').click(function(){
        checkGeneralCurrentState();
    });


    //search
    $(".headerSearchGlobalInputMobile").on('change', function (e) {
        if($(this).val().length > 0){
            $('.headerSearchRemoveIcon').show();
        }else{
            $('.headerSearchRemoveIcon').hide();
        }

        if(blockTempSearch==false){
		    searchNowAfterChange( $(this).val() );
        }
	});

	$(".headerSearchRemoveIcon").click(function () {
		// $('.headerSearchGlobalInputMobile').val('');
        blockTempSearch=true;
        navigateToPage('search');

        setTimeout(() => {
            blockTempSearch=false;
        }, 1000);
	});
    
    
});

// Entry di un video nella history: la pagina video è UNICA, quindi un video
// aperto sopra un altro video ne SOSTITUISCE l'entry (mai due video
// adiacenti). Idempotente se l'entry è già quella corrente.
function pushVideoLayer(id){
    if (Nav.top() && Nav.top().indexOf('video-') === 0) {
        Nav.replaceTop('video-' + id);
    } else {
        Nav.push('video-' + id);
    }
}

// "Indietro" programmatico (X delle modali, swipe-down, bottoni in pagina):
// passa da Nav.back() → history.back() → popstate → gestori sotto.
// Stesso identico percorso del tasto/gesture Android: mai più desincronizzati.
function checkGeneralCurrentState(){
    Nav.back();
}

// ---------------------------------------------------------------------------
// Renderer unico della navigazione: chiamato da nav.js ad OGNI traversata
// della history (indietro E avanti) con il layer di destinazione. Le modali
// non arrivano mai qui (le gestisce nav.js); qui solo pagine.
// ---------------------------------------------------------------------------
function restorePreviousLayer(target, from){
    // effetti collaterali del layer che si sta lasciando
    if(from && from.indexOf('video-') === 0){
        // richiesta video eventualmente in volo: va fermata, o renderizzerebbe
        // (e avvierebbe) il player su una pagina ormai nascosta
        try{ if(currentAjaxRequest){ currentAjaxRequest.abort(); } }catch(err){}
    }
    if(from && from.indexOf('searchin') === 0){
        $('#mainLiveHomeMobile').html('');
    }

    // layer 'shorts-*' legacy (feature Shorts rimossa): fallback sulla home
    if(!target || target.indexOf('shorts') === 0){ navigateToPage('home', true); return; }
    if(target.indexOf('searchin') === 0){
        $('#mainLiveHomeMobile').html('');
        var splitted = target.split('-');
        clickedBrowseAll(splitted[1] || '', splitted[2] || '', splitted.slice(3).join('-'), false);
        return;
    }
    if(target.indexOf('video-') === 0){
        var idVideo = target.split('-')[1];
        if(idVideo && idVideo !== 'null'){
            loadPageVideo(idVideo);
        }else{
            // video offline/senza id: non ripristinabile
            navigateToPage('home', true);
        }
        return;
    }
    if(target.indexOf('collection') === 0){
        // la pagina collection era stata svuotata: va rigenerata
        openSerieThumb(target.split('-')[1], true);
        return;
    }
    if(target.indexOf('playlist-') === 0){
        openSharedPlaylist(target.slice(9));
        return;
    }
    if(target.indexOf('page-') === 0){
        openCustomPageLayer(target.slice(5));
        return;
    }
    // pagine pagamenti (solo web): ri-render dai moduli web-payments
    if(window.TY_WEB && target.indexOf('checkout') === 0 && typeof openModalPaymentPreview === 'function'){
        openModalPaymentPreview(target.split('-')[1] || null);
        return;
    }
    if(window.TY_WEB && target === 'giftcard' && typeof loadPageGiftcard === 'function'){ loadPageGiftcard(); return; }
    if(window.TY_WEB && target === 'giftcard_redeem' && typeof loadPageUnlockGiftcard === 'function'){ loadPageUnlockGiftcard(); return; }
    if(window.TY_WEB && target === 'payments' && typeof tyWebOpenPayments === 'function'){ tyWebOpenPayments(); return; }
    navigateToPage(target, true);
}

// Pagina custom come layer di navigazione ('page-<id>'): entry propria nella
// history (URL /page?id_custom=<id> sul web) e render nel contenitore della
// home. Sotto popstate la push è un no-op (navlock) e si limita al render.
function openCustomPageLayer(id){
    Nav.push('page-' + id);
    currentCustomPageActive = id;
    destroyHomePage(); // forza il re-render col nuovo contenuto
    navigateToPage('home', true);
    $('html, body').scrollTop(0);
    $('.mobile-list-page div').removeClass('active');
    $('.mobile-list-page #header_page_' + id).addClass('active');
}

function backFromSearchMobile(){
    $('#mainLiveHomeMobile').html('');
    $('.resultsSearchTxt').hide();
    $(".navbar-mobile-native .menu-item[rel='search']").trigger('click');
}

function configureNativeLanguages(){
    $('.headerSearchGlobalInputMobile').attr('placeholder', translate('SEARCH'));
    $('#navbar-mobile-label-home').text(translate('HOME'));
    $('#navbar-mobile-label-saved').text(translate('BROWSE_SAVED'));
    $('#navbar-mobile-label-downloads').text(translate('DOWNLOADS'));
    $('#navbar-mobile-label-search').text(translate('SEARCH'));
    $('#categories_label_name').text(translate('CATEGORIES'));
    $('#page-downloades-offline-mode-label').text(translate('YOU_ARE_IN_OFFLINE_MODE'));
}

$('body').on('click', function(event){
    // Verifica se l'elemento cliccato o uno dei suoi genitori ha la classe .headerSearchMicrophoneIcon
    if (!$(event.target).closest('.headerSearchMicrophoneIcon').length) {
        // Se non ha la classe .headerSearchMicrophoneIcon, esegui questa azione
        // alert("test");
        stopListeningNow();
    }
});

function stopListeningNow(back=true){
    try{
        window.plugins.speechRecognition.stopListening();
    }catch(e){}

    if(back==true){
     $('.headerSearchGlobalInputMobile').val('');
    }
    $('.headerSearchMicrophoneIcon').removeClass('headerSearchMicrophoneIcon-hovered');
}

function startInputAudioReco() {
    // Funzione chiamata quando si richiede il permesso per il riconoscimento vocale
    function onRequestPermissionSuccess() {
        let options;
        if (userDevice == 'android') {
            options = {
                showPopup: true,
                showPartial: false,
            }
        } else if (userDevice == 'ios') {
            options = {
                showPopup: false,
                showPartial: true,
                language: userDeviceLanguage,
            }
        }else{
            return false;
        }
        
        // Il permesso è stato concesso, avvia il riconoscimento vocale
        window.plugins.speechRecognition.startListening(startListeningSuccess, startListeningError, options);

        $('.headerSearchGlobalInputMobile').val(translate('SPEAK_TO_SEARCH')+'...');
        $('.headerSearchMicrophoneIcon').addClass('headerSearchMicrophoneIcon-hovered');
    }

    function startListeningSuccess(matches) {
            $('.headerSearchGlobalInputMobile').val(matches[0]);
            searchNowAfterChange(matches[0]);
            if(matches[0].length > 0){
                $('.headerSearchRemoveIcon').show();
            }else{
                $('.headerSearchRemoveIcon').hide();     
            }
            stopListeningNow(false); // Fermiamo il riconoscimento vocale
    }

    // Funzione chiamata in caso di errore nell'avvio del riconoscimento vocale
    function startListeningError(error) {
        console.log(error);
        $('.headerSearchGlobalInputMobile').val('');
        $('.headerSearchMicrophoneIcon').removeClass('headerSearchMicrophoneIcon-hovered');
        console.error("Errore durante il riconoscimento vocale:", error);
    }

    // Funzione per richiedere il permesso per il riconoscimento vocale
    function requestSpeechRecognitionPermission() {
        window.plugins.speechRecognition.requestPermission(onRequestPermissionSuccess, onRequestPermissionError);
    }

    // Funzione chiamata in caso di errore durante la richiesta del permesso
    function onRequestPermissionError(error) {
        console.error("Errore durante la richiesta del permesso per il riconoscimento vocale:", error);
    }

    // Richiedi il permesso per il riconoscimento vocale
    requestSpeechRecognitionPermission();
}

/*gestion bottoni effetti*/
$(document).ready(function() {
    $(document).on('touchstart', '.button-round, .button-primary, .button-secondary', function() {
        var button = $(this);
        var buttonType = this.className.match(/button-\w+/)[0];
        var hoverClass = buttonType + '-hover';
        
        button.addClass(hoverClass);
        
        setTimeout(function() {
            button.removeClass(hoverClass);
        }, 300);
    });
    $(document).on('touchstart', '.transition-zoom', function() {
        
        var button = $(this);
        // Aggiunge la classe temporanea per l'effetto hover
        button.addClass('transition-zoom-hover');
        // Rimuove la classe dopo un breve ritardo
        setTimeout(function() {
            button.removeClass('transition-zoom-hover');
        }, 300); // Tempo in millisecondi
    });
});
//*****//

function cleanInputBoxSearch(){
    $('.headerSearchGlobalInputMobile').val('');
    checkGeneralCurrentState();
}


function generateCustomHomePages(){
    if(companyCustomHomePages && companyCustomHomePages.length > 0){
        $('.mobile-list-page').addClass('mobile-list-page-init');
        $('.pageMob-home').addClass('standardHomeWithPages');
        let htmlPages = `<div id="header_page_user" class="active" onclick="loadCustomPage('1','user');">${translate('ALL')}</div>`;
        companyCustomHomePages.forEach(function(page) {
            htmlPages += `<div id="header_page_${page.id}" onclick="loadCustomPage('page','${page.id}');">${page.title}</div>`;
        });
        $(".mobile-list-page").html(htmlPages);
    }
}

function loadCustomPage(type, page){
    if (page === 'guest' && typeof tyResolveHomePageTarget === 'function') {
        var homeTarget = tyResolveHomePageTarget(type, page);
        type = homeTarget.type;
        page = homeTarget.idCustom;
    }

    // alert(page);
    //prevent self click
    if(currentCustomPageActive != page){
        $('.mobile-list-page div').removeClass('active');
        $('.mobile-list-page #header_page_'+page).addClass('active');
        currentCustomPageActive = page;
        loadHomepageSections(type, CHANNEL_ID, 0, null, null, page);
    }

}   

function getSimilarColor(color, amount = -10) {
  let r, g, b;
  if (color.startsWith('rgb')) {
    // Gestisce il formato RGB
    [r, g, b] = color.match(/\d+/g).map(Number);
  } else {
    // Gestisce il formato esadecimale
    color = color.replace('#', '');
    r = parseInt(color.substr(0,2), 16);
    g = parseInt(color.substr(2,2), 16);
    b = parseInt(color.substr(4,2), 16);
  }
  
  // Aumenta ciascun valore, ma non oltre 255
  r = Math.min(r + amount, 255);
  g = Math.min(g + amount, 255);
  b = Math.min(b + amount, 255);
  
  // Converti di nuovo in hex
  const newHex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
  
  return `#${newHex}`;
}
